/*
    🔥 PUENTE PARA LOS CONFIRM QUE SON COMPONENTES

    sweetalert2 y window.confirm son imperativos: los llamás y devuelven.
    Un Modal de react-bootstrap NO: es un componente que necesita estado.

    Este bus conecta la llamada imperativa confirm() con el componente
    montado, para que puedas hacer `await confirm.danger(...)` desde
    cualquier onClick sin saber qué hay atrás.

    ⚠️ SI NO HAY HOST MONTADO cae al confirm nativo del navegador.
       Antes devolvía false en silencio y parecía que "no pasaba nada".
*/

let LISTENER = null;

export const onIsConfirmHostMounted = () => LISTENER !== null;

export const onSubscribeConfirm = (fn) => {

    LISTENER = fn;

    return () => { if (LISTENER === fn) LISTENER = null; };
};

export const onRequestConfirm = (options = {}) => new Promise((resolve) => {

    if (!LISTENER) {

        console.error(
            '[Confirm] No hay Host montado. Agregá <AppConfirmHost /> en App.js.\n' +
            'Mientras tanto uso el confirm nativo para no perder la acción.',
        );

        const TEXT = options.text ? `${options.title}\n\n${options.text}` : options.title;
        return resolve(window.confirm(TEXT ?? '¿Confirmás la acción?'));
    }

    LISTENER({ options, resolve });
});
